import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { OtherTemplatesService } from '../home/services/other-templates.service';
import {TitleCaseDirective} from '../directives/text-input/title-case.directive';
import {AddressCaseDirective} from '../directives/text-input/address-case.directive';
//import {NgxStripeModule} from "@nomadreservations/ngx-stripe";
import {LibsModule} from '../libs.module';
import {UploadComponent} from './upload/upload.component';
import {UploadDocsRoutes} from './upload-docs.router';
import {UploadDocsService} from './services/upload.service';
import {HomeModule} from '../home/home.module';
import { NgxDropzoneModule } from 'ngx-dropzone';
import {HeaderComponent} from './header/header.component';

import {PaymentTypeSelectorComponent} from '../order-assistant/order/payment-type-selector/payment-type-selector.component';





export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}

@NgModule({
  imports: [
    NgxDropzoneModule,
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forChild(UploadDocsRoutes),
    LibsModule,
    //NgxStripeModule, // MS 2022-03-03 remove stripe
    HomeModule,

  ],
  declarations: [
    UploadComponent,
    HeaderComponent

  ],
  entryComponents: [

  ],
  providers: [
    OtherTemplatesService,
    UploadDocsService
  ]
})
export class UploadDocsModule { }
